export enum EEditableSections {
  OVERVIEW = "overview",
  PROFILE = "profile",
  MARKET = "market",
  COMPETITORS = "competitors",
  PRODUCTS = "products",
  TEAM = "team"
}
